import { c as _c } from "react/compiler-runtime";
import { Button } from '@chakra-ui/react';
import { advisorsBreadcrumbsWithTrail, useAdvisorsToolbar } from '@src/components/sco/Advisors/hooks/useAdvisorsToolbar';
import { AdvisorsSubNavLayout } from '@src/components/sco/Advisors/layout/AdvisorsSubNavLayout';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { acceptingSessionsDirectoryHref } from '@src/components/sco/Advisors/utils/directoryFilters';
import { sessionsNavItems, SessionsSectionKey } from '@src/components/sco/Advisors/utils/sessionsNav';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ReactNode } from 'react';
import { LuCalendarPlus } from 'react-icons/lu';

/**
 * Sessions shell — sub-nav rail plus section content.
 *
 * Bucket views (All / Needs action / Upcoming / Past) are the list filters.
 * Book a Session is the rail CTA and opens the directory with the
 * accepting-sessions filter on. Rates and payouts live under My Advisor Profile.
 */
export const SessionsLayout = t0 => {
  const $ = _c(16);
  const {
    activeKey,
    title,
    description,
    action,
    children
  } = t0;
  const paths = useAdvisorsPaths();
  const navItems = sessionsNavItems(paths);
  let t1;
  if ($[0] !== activeKey) {
    t1 = item => item.key === activeKey;
    $[0] = activeKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeItem = navItems.find(t1);
  const isBucketView = activeKey === "all" || activeKey === "action" || activeKey === "upcoming" || activeKey === "past";
  useAdvisorsToolbar({
    breadcrumbs: isBucketView && activeKey === "all" ? advisorsBreadcrumbsWithTrail({
      title: "My sessions",
      href: paths.sessions
    }) : advisorsBreadcrumbsWithTrail({
      title: "My sessions",
      href: paths.sessions
    }, {
      title: activeItem?.title ?? "Sessions",
      href: activeItem?.href ?? paths.sessions
    })
  });
  const T0 = AdvisorsSubNavLayout;
  const t2 = "Paid video sessions with marketplace advisors.";
  const t3 = "Sessions";
  const t4 = navItems.map(_temp);
  let t5;
  if ($[2] !== paths) {
    t5 = acceptingSessionsDirectoryHref(paths);
    $[2] = paths;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LuCalendarPlus />;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t5) {
    t7 = <Button asChild={true} size="sm" variant="cta" width="full"><NextLink href={t5}>{t6} Book a Session</NextLink></Button>;
    $[5] = t5;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== T0 || $[8] !== action || $[9] !== activeKey || $[10] !== children || $[11] !== description || $[12] !== t4 || $[13] !== t7 || $[14] !== title) {
    t8 = <T0 action={action} activeKey={activeKey} description={description} railDescription={t2} railTitle={t3} title={title} items={t4} railFooter={t7}>{children}</T0>;
    $[7] = T0;
    $[8] = action;
    $[9] = activeKey;
    $[10] = children;
    $[11] = description;
    $[12] = t4;
    $[13] = t7;
    $[14] = title;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp(item_0) {
  return {
    key: item_0.key,
    title: item_0.title,
    href: item_0.href,
    icon: item_0.icon
  };
}